import React, { useEffect, useRef, useState } from "react";
import { FaCloudUploadAlt, FaCamera, FaImages } from "react-icons/fa";
import "./KitchenImages.css";
import { takePicture, pickFromGallery } from "../../utils/cameraUtils";

const KitchenImages = ({ editMode, kitchenData, updateKitchenData }) => {
  const images = kitchenData.images || [];
  const [showOptions, setShowOptions] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (editMode && kitchenData.images && kitchenData.images.length > 0) {
      if (typeof kitchenData.images[0] === "string") {
        updateKitchenData({
          images: kitchenData.images.map((url, index) => ({
            id: index,
            file: null,
            preview: url,
            category: "",
          })),
        });
      }
    }
  }, [editMode, kitchenData.images, updateKitchenData]);

  const handleImageUploadClick = () => {
    setShowOptions(true);
  };

  const handleTakePhoto = async () => {
    try {
      const { file, preview } = await takePicture();
      const newEntry = {
        id: Date.now(),
        file,
        preview,
        category: "",
      };
      updateKitchenData({ images: [newEntry, ...images] });
    } catch (error) {
      console.error("Error taking photo:", error);
    } finally {
      setShowOptions(false);
    }
  };

  const handlePickFromGallery = async () => {
    try {
      const { file, preview } = await pickFromGallery();
      const newEntry = {
        id: Date.now(),
        file,
        preview,
        category: "",
      };
      updateKitchenData({ images: [newEntry, ...images] });
    } catch (error) {
      console.error("Error picking from gallery:", error);
    } finally {
      setShowOptions(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      const newEntry = {
        id: Date.now(),
        file,
        preview,
        category: "",
      };
      updateKitchenData({ images: [newEntry, ...images] });
    }
  };

  const handleRemoveImageEntry = (id) => {
    const entryToRemove = images.find((entry) => entry.id === id);
    if (entryToRemove && entryToRemove.preview) {
      URL.revokeObjectURL(entryToRemove.preview);
    }
    const updatedImages = images.filter((entry) => entry.id !== id);
    updateKitchenData({ images: updatedImages });
  };

  return (
    <div className="kitchen-images">
      <div className="image-upload-section">
        <div className="image-preview-container">
          {images.map((entry) =>
            entry.preview ? (
              <div key={entry.id} className="img-preview">
                <img src={entry.preview} alt={`Preview ${entry.id}`} />
                <button
                  type="button"
                  className="remove-image-btn"
                  onClick={() => handleRemoveImageEntry(entry.id)}
                  aria-label="Remove Image"
                >
                  &times;
                </button>
              </div>
            ) : null
          )}
        </div>
        <div className="upload-icon-container" onClick={handleImageUploadClick}>
          <FaCloudUploadAlt className="upload-icon" />
          <p>Click to upload image</p>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
            hidden
          />
        </div>
      </div>
      {showOptions && (
        <div className="camera-options">
          <button onClick={handleTakePhoto} className="camera-option">
            <FaCamera /> Take Photo
          </button>
          <button onClick={handlePickFromGallery} className="camera-option">
            <FaImages /> Choose from Gallery
          </button>
        </div>
      )}
    </div>
  );
};

export default KitchenImages;
